module.exports = __webpack_public_path__ + "static/img/596060cf1ec843232c2c8507fcbc7060.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/workflow_active_02.png
// module id = giBe
// module chunks = 1